import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/img/icons/logo_jidian.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7373c06b")

_pushScopeId("data-v-7373c06b")
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "svg-container" }, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-user" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "svg-container" }, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-lock" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LangSelect = _resolveComponent("LangSelect")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_LangSelect, {
      isWhite: true,
      class: "set-language"
    }),
    _createVNode(_component_el_form, {
      ref: "loginFormRef",
      model: _ctx.loginForm,
      rules: _ctx.loginRules,
      class: "login-form",
      autocomplete: "on",
      "label-position": "left",
      size: "small"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, { prop: "loginName" }, {
          default: _withId(() => [
            _hoisted_3,
            _createVNode(_component_el_input, {
              ref: "userNameRef",
              modelValue: _ctx.loginForm.loginName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.loginForm.loginName = $event)),
              placeholder: _ctx.t('login.plaseusername'),
              name: "loginName",
              type: "text",
              tabindex: "1",
              autocomplete: "on"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tooltip, {
          modelValue: _ctx.capsTooltip,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.capsTooltip = $event)),
          content: "Caps lock is On",
          placement: "right",
          manual: ""
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withId(() => [
                _hoisted_4,
                _createVNode(_component_el_input, {
                  key: _ctx.passwordType,
                  ref: "passwordRef",
                  modelValue: _ctx.loginForm.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.loginForm.password = $event)),
                  type: _ctx.passwordType,
                  placeholder: _ctx.t('login.plasepassword'),
                  name: "password",
                  tabindex: "2",
                  autocomplete: "on",
                  onKeyup: [
                    _ctx.checkCapslock,
                    _withKeys(_ctx.handleLogin, ["enter"])
                  ],
                  onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.capsTooltip = false))
                }, null, 8, ["modelValue", "type", "placeholder", "onKeyup"]),
                _createVNode("span", {
                  class: "show-pwd",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showPwd && _ctx.showPwd(...args)))
                }, [
                  _createVNode(_component_svg_icon, {
                    name: _ctx.passwordType === 'password' ? 'eye-off' : 'eye-on'
                  }, null, 8, ["name"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode("span", null, [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.isRemember,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isRemember = $event)),
            label: _ctx.t('login.Remember Username'),
            size: "small"
          }, null, 8, ["modelValue", "label"])
        ]),
        _createVNode(_component_el_button, {
          loading: _ctx.loading,
          type: "primary",
          style: {"width":"100%","margin":"15px 0 30px 0"},
          onClick: _withModifiers(_ctx.handleLogin, ["prevent"])
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t("login.logIn")), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.t('login.thirdparty'),
      modelValue: _ctx.showDialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDialog = $event))
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.t("login.thirdpartyTips")) + " ", 1),
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
})